import { apiPaths } from "@/lib/api/backendUrls"
import { fetchJson } from "@/lib/api/http"
import type {
  CreateUpdateUserGroupMembershipDto,
  RejectUserGroupMembershipDto,
  UserGroupMembershipDto,
  UserGroupMembershipForUnverifiedDto,
} from "@/entities/associations/types"

const base = apiPaths.userAssociation

export const getMyMemberships = async (accessToken: string) => {
  return fetchJson<UserGroupMembershipDto[]>(base, { method: "GET", token: accessToken })
}

export const createMyMembership = async (
  accessToken: string,
  data: CreateUpdateUserGroupMembershipDto,
) => {
  return fetchJson<UserGroupMembershipDto>(base, {
    method: "POST",
    token: accessToken,
    body: data,
  })
}

export const updateMyMembership = async (
  accessToken: string,
  id: string,
  data: CreateUpdateUserGroupMembershipDto,
) => {
  return fetchJson<UserGroupMembershipDto>(`${base}/${id}`, {
    method: "PUT",
    token: accessToken,
    body: data,
  })
}

export const deleteMembership = async (accessToken: string, id: string) => {
  return fetchJson<unknown>(`${base}/${id}`, { method: "DELETE", token: accessToken })
}

export const verifyMembership = async (accessToken: string, id: string) => {
  return fetchJson<unknown>(`${base}/${id}/verify`, { method: "POST", token: accessToken })
}

export const rejectMembership = async (
  accessToken: string,
  id: string,
  data: RejectUserGroupMembershipDto,
) => {
  return fetchJson<unknown>(`${base}/${id}/reject`, {
    method: "POST",
    token: accessToken,
    body: data,
  })
}

export const getUnverifiedMemberships = async (accessToken: string) => {
  return fetchJson<UserGroupMembershipForUnverifiedDto[]>(`${base}/unverified`, {
    method: "GET",
    token: accessToken,
  })
}
